// todo: clean multiple format dates. there are two format dates after rebase. One used for dashboard and another for subscription data

/**
 * Formats date to a 'dd Mon YYYY' format
 * @param dateString
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const month = date.toLocaleDateString('en-us', { month: 'short' });

  return `${date.getDate()} ${month} ${date.getFullYear()}`;
};
